export default __webpack_public_path__ + "static/media/image_united_arab_emirates.3e339a17.png";